import { Container, AppBar, Toolbar, IconButton, Typography, Card, CardContent, Divider, SwipeableDrawer, TextField, Skeleton, Box } from '@mui/material';
import { ArrowBackOutlined, KeyboardArrowRightOutlined } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { createNewTheme, descriptografar, descriptografarCompleto, getBandeira, maskValidade } from '../functions/utils';

import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CardHeader from '@mui/material/CardHeader';
import LoadingComponent from '../components/LoadingComponent';
import Snackbar from '@mui/material/Snackbar';

import '@fontsource/roboto/400.css';
import { SpacerMely } from '../components/DesignSystem/SpacerMely';
import { ButtonMely } from '../components/DesignSystem/ButtonMely';

function InformacoesPagamento(props) {

  const { window } = props;
  const state = useLocation().state;

  const [colorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const [formasPagamento, setFormasPagamento] = useState(null);
  const [isInit, setIsInit] = useState(null);
  const [open, setOpen] = useState(false);
  const [modalAlert, setModalAlert] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [numeroCartao, setNumeroCartao] = useState("");
  const [nomeCartao, setNomeCartao] = useState("");
  const [vencimentoCartao, setVencimentoCartao] = useState("");
  const [codigoSegurancaCartao, setCodigoSegurancaCartao] = useState("");
  const [cpfTitular, setCpfTitular] = useState("");
  const [cartaoSelected, setCartaoSelected] = useState("");
  const [cep, setCep] = useState("");
  const [localidade, setLocalidade] = useState("");
  const [bairro, setBairro] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [uf, setUf] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [semLogradouro, setSemLogradouro] = useState(false);
  const [semBairro, setSemBairro] = useState(false);

  const container = window !== undefined ? () => window().document.body : undefined;
  const navigate = useNavigate();

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleBack = () => {
    navigate("/", { replace: true, state: { page: "perfil" } })
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const handleCloseModal = () => {
    setModalAlert(false);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleCartao = (cartao) => {
    setOpen(true)
    setNumeroCartao(descriptografar(cartao.NR_CT))
    setNomeCartao(cartao.NM_USR)
    const [mes, anoLongo] = cartao.VL_CT.split('/');
    setVencimentoCartao(`${mes}/${anoLongo.substr(-2)}`)
    setCodigoSegurancaCartao(cartao.CD_CT)
    setCpfTitular(cartao.CF_TTL)
    setCartaoSelected(cartao)
    const arrEnd = cartao.END_COB.split(", ")
    setLogradouro(arrEnd[0])
    setNumero(arrEnd[1])
    setBairro(arrEnd[2])
    setLocalidade(arrEnd[3])
    setUf(arrEnd[4])
    setCep(arrEnd[5])
    setComplemento(arrEnd[6] ?? "")
  }

  const validarApenasNumerosEspacos = (str) => {
    const regex = /^[0-9\s]+$/;
    return regex.test(str);
  }

  const handleExcluirPagamento = () => {
    handleOpenLoading();
    const urlBase = localStorage.getItem('UBs');
    const idusuarios = localStorage.getItem('iUsr');
    axios.post(`${urlBase}/deletar_formapagamento.php`, {
      idusuarios: idusuarios,
      idcartao: cartaoSelected.ID_FM_PGT,
    })
      .then(response => {
        response = response.data
        if (!response) {
          handleSnack("Não foi possivel excluir, verifique sua conexão e tente novamente.")
          return;
        }

        if (response.resposta === "sucesso atualizar") {
          setNumeroCartao("")
          setNomeCartao("")
          setVencimentoCartao("")
          setCodigoSegurancaCartao("")
          setCpfTitular("")
          setCartaoSelected("")
          getFormasPagamento()
          handleCloseLoading();
          //
          handleCloseModal();
          setOpen(false);
          handleSnack("Forma de pagamento excluída com sucesso.")
          return;
        }

        handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.")
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const handleExcluir = () => {
    setTitle("Atenção!")
    setDescription("Essa é uma ação irreversível, você deseja realmente excluir a forma de pagamento?")
    setModalAlert(true)
  }

  const handleCadastrarForma = () => {
    handleOpenLoading();
    if (!cartaoSelected) {
      const urlBase = localStorage.getItem('UBs');
      const idusuarios = localStorage.getItem('iUsr');
      const [mes, anoCurto] = vencimentoCartao.split('/');
      axios.post(`${urlBase}/cadastro_formapagamento.php`, {
        idusuarios: idusuarios,
        nome: nomeCartao,
        numero: numeroCartao,
        validade: `${mes}/20${anoCurto}`,
        codigo: codigoSegurancaCartao,
        cpfTitular: cpfTitular,
        endereco: `${logradouro}, ${numero}, ${bairro}, ${localidade}, ${uf}, ${cep.replace(/\D/g, '')}, ${complemento ?? ""}`.trim(),
        tipo: "credito"
      })
        .then(response => {
          response = response.data
          if (!response) {
            handleSnack("Não foi possivel conectar cadastrar-se, verifique sua conexão e tente novamente.")
            return;
          }
          if (response.resposta === "nome invalido") {
            handleSnack("O nome digitado não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "numero invalido") {
            handleSnack("O número do cartão não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "mes invalido") {
            handleSnack("O mês do cartão não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "ano invalido") {
            handleSnack("O ano do cartão não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "cartao vencido") {
            handleSnack("O cartão está vencido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "codigo invalido") {
            handleSnack("O código de segurança do cartão não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "falha") {
            handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.")
            return;
          }

          setOpen(false)
          setNumeroCartao("")
          setNomeCartao("")
          setVencimentoCartao("")
          setCodigoSegurancaCartao("")
          setCpfTitular("")
          setCartaoSelected("")
          getFormasPagamento()
          handleCloseLoading();
          handleSnack("Forma de pagamento cadastrada com sucesso.")
        })
        .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
    } else {
      const urlBase = localStorage.getItem('UBs');
      let numeroCard = numeroCartao
      if (descriptografar(cartaoSelected.NR_CT) === numeroCartao) {
        numeroCard = descriptografarCompleto(cartaoSelected.NR_CT)
      }

      if (!validarApenasNumerosEspacos(numeroCard)) {
        handleSnack("Você precisa preencher o número do cartão novamente para alterar.")
        return;
      }

      const [mes, anoCurto] = vencimentoCartao.split('/');
      axios.post(`${urlBase}/atualiza_formapagamento.php`, {
        idcartao: cartaoSelected.ID_FM_PGT,
        nome: nomeCartao,
        numero: numeroCard,
        validade: `${mes}/20${anoCurto}`,
        codigo: codigoSegurancaCartao,
        cpfTitular: cpfTitular,
        endereco: `${logradouro}, ${numero}, ${bairro}, ${localidade}, ${uf}, ${cep.replace(/\D/g, '')}, ${complemento ?? ""}`.trim(),
        tipo: "credito"
      })
        .then(response => {
          response = response.data
          if (!response) {
            handleSnack("Não foi possivel conectar cadastrar-se, verifique sua conexão e tente novamente.")
            return;
          }
          if (response.resposta === "nome invalido") {
            handleSnack("O nome digitado não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "numero invalido") {
            handleSnack("O número do cartão não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "mes invalido") {
            handleSnack("O mês do cartão não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "ano invalido") {
            handleSnack("O ano do cartão não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "cartao vencido") {
            handleSnack("O cartão está vencido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "codigo invalido") {
            handleSnack("O código de segurança do cartão não é válido, verifique e tente novamente.")
            return;
          }

          if (response.resposta === "falha") {
            handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.")
            return;
          }

          setOpen(false)
          setNumeroCartao("")
          setNomeCartao("")
          setVencimentoCartao("")
          setCodigoSegurancaCartao("")
          setCpfTitular("")
          setCartaoSelected("")
          getFormasPagamento()
          handleCloseLoading();
          handleSnack("Forma de pagamento atualizada com sucesso.")
        })
        .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
    }
  }

  useEffect(() => {
    handleOpenLoading();

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`;

    getFormasPagamento();

    setIsInit(true);
    handleCloseLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNumeroCartao = (event) => {
    let valor = event.target.value.replace(/\D/g, '');
    valor = valor.replace(/(.{4})/g, '$1 ').trim();
    setNumeroCartao(valor.slice(0, 19));
  };

  const handleNomeCartao = (event) => {
    setNomeCartao(event.target.value.toUpperCase())
  };

  const handleVencimentoCartao = (event) => {
    setVencimentoCartao(maskValidade(event.target.value));
  };

  const handleCodigoSegurancaCartao = (event) => {
    setCodigoSegurancaCartao(event.target.value)
  };

  const handleCpfTitular = (event) => {
    setCpfTitular(event.target.value)
  };

  const handleCepChange = (event) => {
    setCep(event.target.value)
    if (event.target.value && !event.target.value.includes("-") && event.target.value.length === 8) {
      handleContinuarCep(event.target.value)
      return
    }
    else if (event.target.value && event.target.value.length === 9) {
      const cepSemHifen = event.target.value.replaceAll("-", "")
      handleContinuarCep(cepSemHifen)
      return
    }
    handleClear()
  };

  const handleClear = () => {
    setLogradouro("")
    setBairro("")
    setNumero("")
    setComplemento("")
    setUf("")
    setLocalidade("")
  };

  const handleLogradouro = (event) => {
    setLogradouro(event.target.value)
  };

  const handleBairro = (event) => {
    setBairro(event.target.value)
  };

  const handleNumero = (event) => {
    setNumero(event.target.value)
  };

  const handleComplemento = (event) => {
    setComplemento(event.target.value)
  };

  // const handleContinuarCep = (cep) => {
  //   handleOpenLoading();
  //   axios.get('https://viacep.com.br/ws/' + cep + '/json')
  //     .then(response => {
  //       response = response.data
  //       if (!response) {
  //         handleSnack("Por favor, preencha todos os campos corretamente para prosseguir.");
  //         return
  //       }
  //       if (response.erro) {
  //         handleSnack("Não foi possivel encontrar o CEP, por favor verifique sua conexão com a internet.");
  //         return
  //       }
  //       setLogradouro(response.logradouro)
  //       setBairro(response.bairro)
  //       setLocalidade(response.localidade)
  //       setUf(response.uf)
  //       response.logradouro ? setSemLogradouro(false) : setSemLogradouro(true)
  //       response.bairro ? setSemBairro(false) : setSemBairro(true)
  //       handleCloseLoading();
  //     })
  //     .catch(error => handleErrorCep());
  // };

  const handleContinuarCep = (cep) => {
    handleOpenLoading();
    axios.get('https://brasilapi.com.br/api/cep/v1/' + cep)
      .then(response => {
        console.log(response)
        response = response.data
        if (!response) {
          handleSnack("Por favor, preencha todos os campos corretamente para prosseguir.");
          return
        }
        if (response.erro) {
          handleSnack("Não foi possivel encontrar o CEP, por favor verifique sua conexão com a internet.");
          return
        }
        setLogradouro(response.street)
        setBairro(response.neighborhood)
        setLocalidade(response.city)
        setUf(response.state)
        response.street ? setSemLogradouro(false) : setSemLogradouro(true)
        response.neighborhood ? setSemBairro(false) : setSemBairro(true)
        handleCloseLoading();
      })
      .catch(error => handleErrorCep());
  };

  const handleErrorCep = () => {
    handleSnack("Não foi possivel encontrar o cep, por favor verifique sua conexão com a internet.");
    handleCloseLoading();
  };

  const getFormasPagamento = () => {
    const urlBase = localStorage.getItem('UBs');
    const idusuarios = localStorage.getItem('iUsr');
    axios.get(`${urlBase}/formas-pagamento-usr.php?idusuarios=${idusuarios}`)
      .then(response => {
        if (response.data) {
          setIsInit(true);
          setFormasPagamento(response.data);
          handleCloseLoading();
          return;
        }
        setIsInit(true);
        setFormasPagamento([]);
        handleCloseLoading();
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const handleNovo = () => {
    setOpen(true)
    setNumeroCartao("")
    setNomeCartao("")
    setVencimentoCartao("")
    setCodigoSegurancaCartao("")
    setCpfTitular("")
    setCartaoSelected("")
    setCep("")
    handleClear()
  }

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>
        {isInit ? (
          <>
            <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
              <Toolbar>
                <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#FFF" }} onClick={handleBack}>
                  <ArrowBackOutlined />
                </IconButton>
                Formas de pagamento
              </Toolbar>
            </AppBar>

            <LoadingComponent open={loading} />

            <Snackbar
              open={openSnack}
              autoHideDuration={3000}
              onClose={handleClose}
              message={msgSnack}
            />

            <Dialog
              open={modalAlert}
              onClose={handleCloseModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {title}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {description}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Box sx={{ p: "12px" }}>
                  <ButtonMely fullWidth={false} style={{ margin: 2 }} color="error" onClick={handleCloseModal}>Cancelar</ButtonMely>
                  <ButtonMely fullWidth={false} style={{ margin: 2 }} onClick={handleExcluirPagamento}>Confirmar</ButtonMely>
                </Box>
              </DialogActions>
            </Dialog>

            <SpacerMely height={83} />

            {formasPagamento && (
              <>
                {formasPagamento.length === 0 && (
                  <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
                    <Typography style={{ textAlign: "center", fontSize: "12px", color: "#999", minWidth: "300px" }}>

                      <img alt="sem formas de pagamento" src="https://dedicado.mely.online/imagens/no-order.png" />

                      <SpacerMely height={10} />

                      Você ainda não possui forma de pagamento. <br />Que tal criar a primeira agora?

                      <SpacerMely height={20} />

                    </Typography>
                  </Typography>
                )}
              </>
            )}

            {formasPagamento ? (
              <>
                {formasPagamento.map((cartao) => (
                  <>
                    <Card variant="outlined" sx={{ borderRadius: "8px", position: "relative" }}>
                      <CardHeader
                        avatar={<img alt="bandeira" src={`${localStorage.getItem('UBs').replaceAll("/api", "")}/imagens/${getBandeira(cartao.NR_CT)}.png`} style={{ width: 40 }} />}
                        action={
                          <IconButton aria-label="settings" onClick={() => handleCartao(cartao)}>
                            <KeyboardArrowRightOutlined />
                          </IconButton>
                        }
                        title={descriptografar(cartao.NR_CT)}
                        titleTypographyProps={{ fontWeight: "bold" }}
                      />
                      <Divider />
                      <CardContent>
                        <Typography style={{ fontSize: "12px", color: "#999" }}>
                          {cartao.NM_USR}
                          <b style={{ float: "right" }}>{cartao.VL_CT}</b>
                        </Typography>
                      </CardContent>
                      {/* <img src={Logo} style={{ width: 300, position: "absolute", right: 10, top: -65, opacity: .03}} /> */}
                    </Card>
                    <SpacerMely height={24} />
                  </>
                ))}
              </>
            ) : (
              <>
                <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                  <CardHeader
                    action={
                      <IconButton aria-label="settings">
                        <KeyboardArrowRightOutlined />
                      </IconButton>
                    }
                    title={
                      <>
                        <Skeleton animation="wave" height={36} width="240px" />
                      </>
                    }
                    titleTypographyProps={{ fontWeight: "bold" }}
                    style={{ color: "#1976d2" }}
                  />
                  <Divider />
                  <CardContent>
                    <Typography style={{ fontSize: "12px", color: "#999" }}>
                      <Skeleton animation="wave" height={36} width="240px" />
                    </Typography>
                  </CardContent>
                  <SpacerMely height={16} />
                </Card>
              </>
            )}


            <SwipeableDrawer
              container={container}
              anchor="bottom"
              open={open}
              onClose={toggleDrawer(false)}
              onOpen={toggleDrawer(true)}
              disableSwipeToOpen={true}
              ModalProps={{
                keepMounted: true,
              }}
            >
              <Box style={{ backgroundColor: "#D6D6D6", height: "4px", width: "32px", borderRadius: "100px", margin: "15px auto" }}>&nbsp;</Box>
              
              <Typography style={{ fontSize: "16px", paddingLeft: "20px", color: "#333", fontWeight: "bold", marginTop: 14 }}>
                {cartaoSelected ? "Editar forma de pagamento" : "Cadastrar forma de pagamento"}
              </Typography>
              <Typography style={{ paddingLeft: "20px", fontSize: "12px", fontWeight: "600", marginTop: 20 }}>
                Número do cartão <b style={{ color: "#A51D1D" }}>*</b>
              </Typography>
              <SpacerMely height={4} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={numeroCartao}
                  onChange={handleNumeroCartao}
                  variant="outlined"
                  placeholder="Número do cartão"
                  type="text"
                />
              </Typography>

              <SpacerMely height={10} />
              <Typography style={{ paddingLeft: "20px", fontSize: "12px", fontWeight: "600" }}>
                Nome <b style={{ color: "#A51D1D" }}>*</b>
              </Typography>
              <SpacerMely height={4} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={nomeCartao}
                  onChange={handleNomeCartao}
                  variant="outlined"
                  placeholder="Nome"
                  type="text"
                />
              </Typography>

              <SpacerMely height={10} />
              <Typography style={{ paddingLeft: "20px", fontSize: "12px", fontWeight: "600" }}>
                Vencimento <b style={{ color: "#A51D1D" }}>*</b>
              </Typography>
              <SpacerMely height={4} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={vencimentoCartao}
                  onChange={handleVencimentoCartao}
                  variant="outlined"
                  placeholder="Vencimento"
                  type="text"
                />
              </Typography>

              <SpacerMely height={10} />
              <Typography style={{ paddingLeft: "20px", fontSize: "12px", fontWeight: "600" }}>
                Código de segurança <b style={{ color: "#A51D1D" }}>*</b>
              </Typography>
              <SpacerMely height={4} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={codigoSegurancaCartao}
                  onChange={handleCodigoSegurancaCartao}
                  variant="outlined"
                  placeholder="Código de segurança"
                  type="text"
                />
              </Typography>

              <SpacerMely height={10} />
              <Typography style={{ paddingLeft: "20px", fontSize: "12px", fontWeight: "600" }}>
                CPF do titular do cartão <b style={{ color: "#A51D1D" }}>*</b>
              </Typography>
              <SpacerMely height={4} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={cpfTitular}
                  onChange={handleCpfTitular}
                  variant="outlined"
                  placeholder="CPF do titular"
                  type="text"
                />
              </Typography>

              <Divider style={{ margin: 20 }} />
              <Typography style={{ paddingLeft: "20px", fontSize: "14px", fontWeight: "600" }}>
                Dados para endereço cobrança
              </Typography>

              <Typography style={{ paddingLeft: "20px", fontSize: "12px", fontWeight: "600", marginTop: 10 }}>
                CEP <b style={{ color: "#A51D1D" }}>*</b>
              </Typography>
              <SpacerMely height={4} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={cep}
                  onChange={handleCepChange}
                  variant="outlined"
                  placeholder="CEP"
                  type="text"
                  inputProps={{ maxLength: 9 }}
                />
              </Typography>

              {logradouro &&
                <>
                  <Typography style={{ paddingLeft: "20px", fontSize: "16px", fontWeight: "500", marginTop: 10 }}>
                    {semLogradouro ? "" : `${logradouro}, `}{semBairro ? "" : `${bairro}, `}{localidade}, {uf}, {cep}
                  </Typography>

                  {semLogradouro &&
                    <>
                      <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                        <TextField
                          fullWidth
                          hiddenLabel
                          value={logradouro}
                          onChange={handleLogradouro}
                          variant="outlined"
                          placeholder="Logradouro (Nome da rua)"
                          type="text"
                        />
                      </Typography>
                      <SpacerMely height={12} />
                    </>
                  }
                  {semBairro &&
                    <>
                      <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                        <TextField
                          fullWidth
                          hiddenLabel
                          value={bairro}
                          onChange={handleBairro}
                          variant="outlined"
                          placeholder="Bairro"
                          type="text"
                        />
                      </Typography>
                      <SpacerMely height={12} />
                    </>
                  }

                  <Typography style={{ paddingLeft: "20px", fontSize: "12px", fontWeight: "600", marginTop: 10 }}>
                    Numero <b style={{ color: "#A51D1D" }}>*</b>
                  </Typography>
                  <SpacerMely height={4} />
                  <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                    <TextField
                      fullWidth
                      hiddenLabel
                      value={numero}
                      onChange={handleNumero}
                      variant="outlined"
                      placeholder="Número"
                      type="text"
                    />
                  </Typography>

                  <Typography style={{ paddingLeft: "20px", fontSize: "12px", fontWeight: "600", marginTop: 10 }}>
                    Complemento
                  </Typography>
                  <SpacerMely height={4} />
                  <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                    <TextField
                      fullWidth
                      hiddenLabel
                      value={complemento}
                      onChange={handleComplemento}
                      variant="outlined"
                      placeholder="Complemento"
                      type="text"
                    />
                  </Typography>
                </>
              }
              <Box sx={{ p: "20px" }}>
                <ButtonMely onClick={() => handleCadastrarForma()}>{cartaoSelected ? "Salvar" : "Cadastrar"}</ButtonMely>
                {cartaoSelected &&
                  <ButtonMely color="error" style={{ marginTop: 16}} onClick={() => handleExcluir()}>Excluir</ButtonMely>
                }
              </Box>
            </SwipeableDrawer>

            <SpacerMely height={100} />
          </>
        ) : (
          <>

            <Skeleton animation="wave" style={{ position: "absolute", top: "0", left: "0", right: "0", borderRadius: "0", height: "80px", marginTop: "-18px" }} />

            <SpacerMely height={70} />

            <Card variant="outlined" sx={{ borderRadius: "8px" }}>
              <CardHeader
                action={
                  <IconButton aria-label="settings">
                    <KeyboardArrowRightOutlined />
                  </IconButton>
                }
                title={
                  <>
                    <Skeleton animation="wave" height={36} width="240px" />
                  </>
                }
                titleTypographyProps={{ fontWeight: "bold" }}
                style={{ color: "#1976d2" }}
              />
              <Divider />
              <CardContent>
                <Typography style={{ fontSize: "12px", color: "#999" }}>
                  <Skeleton animation="wave" height={36} width="240px" />
                </Typography>
              </CardContent>
              <SpacerMely height={16} />
            </Card>
          </>
        )}
        <Box style={{ borderTop: `solid 1px rgba(${colorPrimary})`, position: "fixed", bottom: "0", right: "0", left: "0", backgroundColor: "white", padding: "16px 16px 16px 16px" }}>
          <ButtonMely onClick={handleNovo}>
            Novo cartão
          </ButtonMely>
        </Box>
      </Container >
    </ThemeProvider>
  );
}

export default InformacoesPagamento;